/*
 * changePassword Sagas
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 19-Sep-2024
 */

import { put, take, call, all } from 'redux-saga/effects'
import { doLocalLoading } from 'Store/actions/loading'
import * as api from 'Api/changePassword/changePassword'
import * as actions from '../actions/changePassword'

export function* changePassword(payload) {
  const params = {}

  if (payload?.currentPassword && payload?.newPassword) {
    params.password = payload?.currentPassword
    params.newPassword = payload?.newPassword
  }

  yield put(doLocalLoading(true))
  yield put(actions.savePassword.request(params))
  const { error, response } = yield call(api.callChangePassword, params)
  if (!error) {
    yield put(doLocalLoading(false))
    yield put(actions.savePassword.success(response.data))
  } else {
    yield put(doLocalLoading(false))
    yield put(actions.savePassword.failure(response, { ...error, ignoreSystemError: true }))
  }
}

// @generator saga

// @generator saga:watch

export function* watchChangePassword() {
  while (true) {
    const payload = yield take(actions.actionTypes.DO_CHANGE_PASSWORD)
    yield call(changePassword, { ...payload })
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* rootSaga() {
  yield all([
    watchChangePassword()
    // @generator saga:fork
  ])
}
